<template>
    <div class="card card-dashboard-thirteen mg-b-20"  v-loading='loading' style="height:380px">
        <label class="az-content-label">Membership Age Profile</label>
        <p class="az-content-text">You have <strong style="color:black">{{age_gt_70.length+age_60_70.length+age_50_60.length+age_lt_50.length}}</strong> members. percentage is calculated based on number of members in each age group over total number of members.</p>
        <div class="row mg-t-20 mg-b-20">
            <div class="col-lg-4" v-show="!isShow">
                <chart-member-age v-if="isChartShow" :all_ages="all_ages" class="wd-100p ht-250" />
            </div><!-- col -->
            <div class="mg-t-40 mg-lg-t-0 col-lg-8" style="display: flex;flex-wrap:wrap;">
                <div class="row">
                    <div class="card bd-0 mg-t-5 pd-b-20" style="height:100%;" v-show="isShow">
                        <div class="card-header bd bd-b-0 tx-medium tx-black">
                            {{title_detail}}
                            <!-- <input v-model="message" placeholder="test"> -->
                            <button type="button" class="close" aria-label="Close" style="float:right">
                                <span aria-hidden="true" @click="getshow()">&times;</span>
                            </button>
                        </div><!-- card-header -->
                        <div class="card-body bd bd-t-0" style="height:200px">
                            <div class="table-responsive" style="height:180px" >
                                <table class="table mg-b-0" style="height:180px;table-layout:fixed">
                                    <thead>
                                        <tr>
                                            <th>Fund</th>
                                            <th>Member</th>
                                            <th width=15%>Age</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for='(detail,index) in table_detail' :key='detail.id'>
                                            <td class="tx-medium">
                                                <router-link :to="{path:'/funddashboard/'+detail.smsf__fund_code,query:{name:detail.smsf__fund_name}}">
                                                    {{isSample?'Sample Family Super Fund '+(index+1):detail.smsf__fund_name}}
                                                </router-link>
                                            </td>
                                            <td>
                                                <router-link :to="{path:'/funddashboard/'+detail.smsf__fund_code+'/memberbasic/',query:{name:detail.smsf__fund_name,page:'Mamber Basic Details'}}">
                                                    {{isSample?'Mr Mike Sample '+(index+1):detail.trustee_name}}
                                                </router-link>
                                            </td>
                                            <td>{{detail.age}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div><!-- table-responsive -->
                        </div><!-- card-body -->
                    </div><!-- card -->
                    <div v-show="!isShow" v-for="(age_group,i) in age_groups" :key="age_group.title" class="media wd-half">
                        <div class="media-icon" :style={color:colorList[i]}>
                            <i class="icon ion-ios-man"></i>
                        </div>
                        <div class="media-body">
                            <h6 style="font-size: 20px;">{{age_group.num_member}} <span>({{age_group.percentage}}%)</span> 
                                <!-- <a href="" style="font-size:12px;color:gray"><i class="typcn typcn-th-list"></i></a> -->
                                <a v-if="age_group.num_member" style="font-size:18px;color:gray" @click="showDetail(age_group.title)" role="button" aria-expanded="false">
                                    <i class="fa fa-file-text"></i>
                                </a>
                            </h6>
                            <label>{{age_group.num_member>1?'Members '+age_group.title:'Member '+age_group.title}}</label>
                            <h6 style="font-size: 20px;">{{age_group.number_funds}} </h6>
                            <label>{{age_group.number_funds>1?'Funds related':'Fund related'}}</label>
                        </div><!-- media-body -->
                    </div><!-- media -->
                </div><!-- row -->
            </div><!-- col -->
        </div><!-- row -->
    </div><!-- card -->

</template>
<script>
export default {
    name:'memberage',
    components: {
        ChartMemberAge : () => import('../charts/ChartMemberAge.vue')
    },
    data(){
        return{
            isSample:false,
            isShrink:false,
            isChartShow: false,
            isShow:false,
            all_ages:[],
            age_gt_70:[],
            age_60_70:[],
            age_50_60:[],
            age_lt_50:[],
            age_groups:[],
            colorList:['#03045e','#0077b6','#00b4d8','#90e0ef'],
            title_detail:'',
            table_detail:null,
            message:'',
            loading:true
        }
    },
    created(){
        this.getMemberAges();
    },
    methods:{
        getMemberAges(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            this.isSample = userdetail['sample'];
            let brand = localStorage.getItem('brand_code')
            this.$api.adviserdashboard_api.memberAgeProfile(brand).then(response =>{
                // let ages_with_id = response.data["total"];
                this.age_gt_70 = response.data["gt_70"];
                this.age_60_70 = response.data["60_70"];
                this.age_50_60 = response.data["50_60"];
                this.age_lt_50 = response.data["lt_50"];
                this.age_groups = response.data["age_groups"].reverse();
                this.all_ages = this.getAllAgesArray(this.age_groups);
                // this.age_groups = age_groups_raw.filter((ele)=>{
                //     return ele.num_member != 0
                // })
                // this.age_groups.reverse()
                
                // this.age_groups = age_groups_raw.reverse();
                this.isChartShow = true
                this.loading=false
            })
        },
        getAllAgesArray(JSONArray){
            let finalArray = JSONArray.map((obj)=>{
                return obj.num_member;
            });
            return finalArray
        },
        getshow(){
            this.isShow= !this.isShow
        },
        showDetail(title){
            this.title_detail = title
            this.isShow = !this.isShow
            title==='BELOW AGE 50'? this.table_detail = this.age_lt_50
            :title==='AGED BETWEEN 50-60'? this.table_detail = this.age_50_60
            :title==='AGED BETWEEN 60-70'? this.table_detail = this.age_60_70
            :this.table_detail = this.age_gt_70

        }

    }
}

</script>
<style scoped>
@import '../../../../static/lib/line-awesome/css/line-awesome-font-awesome.min.css';
.mg-r-10{
    margin-right:10%
}
.wd-half{
    width:50%
}
</style>